"use strict";

define('uikit/modules/modal',['require','exports','module','underscore','marionette','../mixins/component.mixin','../collections/container','../collections/grid','../templates','../channel','../extra/size','../extra/transition','../helper/dom','semantic/modules/modal'],function (require, exports, module) {
  var _ = require('underscore');
  var Mn = require('marionette');
  var ComponentMixin = require('../mixins/component.mixin');
  var ContainerView = require('../collections/container');
  var Grid = require('../collections/grid');
  var Templates = require('../templates');
  var channel = require('../channel');
  var Size = require('../extra/size');
  var Transition = require('../extra/transition');
  var DOMHelper = require('../helper/dom');
  require('semantic/modules/modal');
  var DefaultModalHeader = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'header',
    template: Templates.UIKit['modal.header'],
    options: {
      text: ''
    }
  });
  var DefaultModalContent = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'content',
    template: Templates.UIKit['modal.content'],
    options: {
      text: '',
      icon: ''
    }
  });
  var DefaultModalActions = ContainerView.extend({
    className: 'actions',
    events: {
      'keydown': function keydown(ev) {
        if (ev.keyCode === 9 && !this.getBoolOption('basic') && this.actions && this.actions.options.actions === "default") {
          ev.stopPropagation();
          ev.preventDefault();
          $(this.el).find($(ev.target).hasClass("ok") ? '.cancel' : '.ok').focus();
        }
      }
    },
    addApprove: function addApprove(view) {
      if (this.getOption('ariaControlsId')) {
        view.$el.attr({
          'aria-controls': this.getOption('ariaControlsId')
        });
      } else {
        view.$el.removeAttr('aria-controls');
      }
      view.$el.addClass('ok');
      this.add(view);
      return this;
    },
    addDeny: function addDeny(view) {
      view.$el.addClass('cancel');
      this.add(view);
      return this;
    }
  });
  var FluidModalActions = DefaultModalActions.extend({
    template: Templates.UIKit['modal.actions.fluid'],
    ui: {
      buttons: '.buttons'
    },
    updateAttributes: function updateAttributes() {
      var size = this.getOption('size') ? Grid.getSizeClass(this.getOption('size')) : Grid.getSizeClass(this._views.length);
      if (this._previousSize) {
        this.ui.buttons.removeClass(this._previousSize);
      }
      this._previousSize = size;
      this.ui.buttons.addClass(size);
    },
    appendView: function appendView(view) {
      view.inverted = this.getOption('basic');
      this.ui.buttons.append(view.$el);
      return this;
    }
  });
  var Modal = Mn.ItemView.extend(ComponentMixin).extend({
    className: 'ui modal',
    attributes: function attributes() {
      return {
        role: this.getOption('role'),
        'aria-modal': 'true',
        'aria-labelledby': this.cid + '-header',
        'aria-describedby': this.cid + '-content'
      };
    },
    template: Templates.UIKit['modal'],
    options: {
      closeIcon: 'close',
      visible: false,
      allowMultiple: false,
      closable: true,
      transition: 'scale',
      useCSS: true,
      buttons: null,
      fullscreen: false,
      role: 'alertdialog',
      size: '',
      text: '',
      basic: false,
      actions: 'default',
      ariaControlsId: ''
    },
    transitionOptionValues: _.values(Transition),
    sizeOptionValues: _.values(Size),
    actionsOptionValues: ['default', 'fluid'],
    update: {
      visible: false,
      buttons: false,
      fullscreen: false,
      size: false,
      basic: false
    },
    events: {
      'keydown .close': function keydown_Close(ev) {
        if (ev.keyCode == 13) {
          ev.target.click();
        }
      },
      'keydown': function keydown(ev) {
        if (ev.keyCode === 9 && !this.getBoolOption('basic') && this.actions && this.actions.options.actions === "default") {
          ev.stopPropagation();
          ev.preventDefault();
          $(this.el).find($(ev.target).hasClass("ok") ? '.cancel' : '.ok').focus();
        }
      }
    },
    initialize: function initialize(options) {
      this.on('change:visible', function () {
        if (this.visible && !this.isRendered) {
          this.render();
          this.show({
            force: true
          });
        }
      });
      ComponentMixin.initialize.apply(this, arguments);
      if (!this.header && this.header !== false) {
        this.header = new DefaultModalHeader({
          modal: this
        });
      }
      if (!this.content) {
        this.content = new DefaultModalContent({
          modal: this
        });
      } else {
        this.content.options.modal = this;
      }
      if (_.isString(this.actions)) {
        var ignoredOptions = ['visible'];
        switch (this.actions) {
          case 'default':
            this.actions = new DefaultModalActions(_.extend({
              modal: this
            }, _.omit(this.options, ignoredOptions)));
            break;
          case 'fluid':
            this.actions = new FluidModalActions(_.extend({
              modal: this
            }, _.omit(this.options, ignoredOptions)));
            break;
        }
      }
      this.on('before:render', this.initializeAriaLabels);
      this.on('render', this.attachModalOptions);
    },
    updateAttributes: function updateAttributes() {
      this.addClass('fullscreen', this.getBoolOption('fullscreen')).addClass(this.getOption('size'), this.getBoolOption('size')).addClass('basic', this.getBoolOption('basic')).addClass('standard', !this.getBoolOption('size') && !this.getBoolOption('basic'));
    },
    initializeAriaLabels: function initializeAriaLabels(view) {
      view.header.$el.attr('id', view.cid + '-header');
      view.content.$el.attr('id', view.cid + '-content');
      view.actions.$el.attr('id', view.cid + '-actions');
    },
    attachModalOptions: function attachModalOptions() {
      var self = this;
      this.listenTo(this.actions, 'childview:press', function (btn) {
        var selectors = $.fn.modal.settings.selector,
          el = btn.$el;
        if (el.is(selectors.approve)) {
          self.triggerMethod('approve');
          self.triggerMethod('confirm');
        } else if (el.is(selectors.deny)) {
          self.triggerMethod('deny');
        }
        self.$el.modal('hide');
      });
      this.$el.modal(_.extend({}, this.options, {
        onShow: function onShow() {
          self.triggerMethod('modal:show');
        },
        onVisible: function onVisible() {
          self.triggerMethod('modal:visible');
        },
        onHide: function onHide() {
          self.triggerMethod('modal:hide');
        },
        onHidden: function onHidden() {
          self.triggerMethod('modal:hidden');
        }
      }));
    },
    _show: function _show() {
      if (!this.isRendered) {
        this.render();
      }
      this.$el.modal('show');
    },
    _hide: function _hide() {
      this.$el.modal('hide');
    },
    onModalShow: function onModalShow() {
      var modal = this.$el.get(0);
      $(document.body).on('keydown.modal', function (ev) {
        DOMHelper.stickFocusWithinElement(ev, modal);
      });
      this._internal.visible = true;
    },
    onModalVisible: function onModalVisible() {
      this._internal.visible = true;
    },
    onModalHide: function onModalHide() {
      $(document.body).off('.modal');
      this._internal.visible = false;
    },
    onModalHidden: function onModalHidden() {
      this.$el.css('margin-top', '0px');
      this._internal.visible = false;
    }
  });
  Modal.DefaultActions = DefaultModalActions;
  Modal.FluidActions = FluidModalActions;
  Modal.DefaultHeader = DefaultModalHeader;
  Modal.DefaultContent = DefaultModalContent;
  Modal.SMALL_SIZE = 'small';
  Modal.LARGE_SIZE = 'large';
  channel.reply('modal', function () {
    return Modal;
  });
  module.exports = Modal;
});

